import { os, app} from './platform'

const options = {
  src: 'favicon.ico'
}

const title = (name) => {
  let body, iframe;

  document.title = name;

  if ((app.isWechat() || app.isMZMall()) && os.isIOS()) {
    body = document.getElementsByTagName('body')[0]
    iframe = document.createElement('iframe')
    iframe.src = options.src
    iframe.style.display = 'none'
    iframe.onload = () =>{
      setTimeout(() =>{
        body.removeChild(iframe)
        iframe = null
      }, 0)
    }
    body.appendChild(iframe)
  }
}

title.source = (src)=> {
  options.src = src
}

export default title
